import { render, staticRenderFns } from "./UiDashboardChart.vue?vue&type=template&id=e049fac8&scoped=true&"
import script from "./UiDashboardChart.vue?vue&type=script&lang=js&"
export * from "./UiDashboardChart.vue?vue&type=script&lang=js&"
import style0 from "./UiDashboardChart.vue?vue&type=style&index=0&id=e049fac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e049fac8",
  null
  
)

export default component.exports